import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { NextPageFC } from '@shared/models/next-fc'
import { GetServerSideProps } from 'next'
import { Verif } from 'screens/verif'
import { VerifLayout } from 'screens/verif/layout'

const VerifPage: NextPageFC<void, PageLayoutOwnProps> = () => Verif()

VerifPage.layout = VerifLayout

VerifPage.headProps = {
	title: 'Заявка на кредит',
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	return {
		props: {},
	}
}

export default VerifPage
